<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="5">
            <label>稿件编号：</label>
            <a-input
              placeholder="请输入"
              v-model="queryCode"
              class="query_input"
            />
          </a-col>
          <a-col :span="5">
            <label>标题：</label>
            <a-input
              placeholder="请输入"
              v-model="queryCnTitle"
              class="query_input"
            />
          </a-col>
          <a-col :span="4">
            <label>作者：</label>
            <a-input
              placeholder="请输入"
              v-model="queryAuthorName"
              class="query_input"
            />
          </a-col>
          <a-col :span="4">
            <label>稿件状态：</label>
            <a-select style="width: 80px" v-model="queryReadStatus">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="0">未读</a-select-option>
              <a-select-option value="1">已读</a-select-option>
            </a-select>
          </a-col>
          <a-button type="primary" class="query_btn" @click="query">
            查询
          </a-button>
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
      <div class="sortType" style="float: right">
        排序方式：
        <a-select
          size="small"
          defaultValue="1"
          style="width: 120px"
          @change="sortChange"
          v-model="sort"
        >
          <a-select-option value="1">编号降序</a-select-option>
          <a-select-option value="2">编号升序</a-select-option>
          <a-select-option value="3">时间降序</a-select-option>
          <a-select-option value="4">时间升序</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="data"
          :rowKey="(record) => record.code"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        >
          <span slot="operator" slot-scope="text, record">
            <a href="javascript:void(0);" @click="() => manage(record)">
              稿件处理
            </a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => toOther(record)">
              转送
            </a>
          </span>
          <template slot="sort" slot-scope="text, record, index">
            {{ `${(page - 1) * limit + index + 1}` }}
          </template>
          <span slot="code" slot-scope="text, record">
            <label @click="manuscriptsInfo(record)" class="view_manu">{{
              record.code
            }}</label>
          </span>
          <span slot="cnTitle" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ record.cnTitle }}</span>
              </template>
              <div class="shenglue">
                <label @click="preview(record)" class="view_manu">{{
                  record.cnTitle
                }}</label>
              </div>
            </a-tooltip>
          </span>
          <span slot="readStatus" slot-scope="text">
            {{ text == 1 ? "已读" : "未读" }}
          </span>
        </a-table>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination
          :total="total"
          :showTotal="(total) => `共 ${total} 条`"
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageSizeOptions"
          :defaultPageSize="limit"
          @showSizeChange="onShowSizeChange"
          @change="pageChange"
        />
      </div>
      <a-select
        defaultValue="0"
        class="batch_operation"
        @change="operateChange"
        v-model="operateCode"
      >
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="1">批量导出</a-select-option>
      </a-select>
    </div>
    <a-modal
      title="选择编辑"
      v-model="giveVisible"
      @ok="giveOk"
      okText="选择并提交"
      width="800px"
      centered
      :maskClosable="false"
    >
      <div class="query">
        <label>责编姓名：</label>
        <a-input
          placeholder="请输入"
          v-model="queryEditorName"
          style="width: 150px"
        />
        <a-button type="primary" style="margin-left: 20px" @click="queryEditor">
          筛选
        </a-button>
      </div>
      <div class="table">
        <a-table
          :pagination="false"
          :columns="editorColumns"
          :dataSource="editorData"
          :rowKey="(record) => record.userCode"
        >
          <span slot="select" slot-scope="text, record">
            <label>
              <input
                type="radio"
                name="give"
                :id="record.userCode"
                @click="giveChange(record.userCode)"
              />
              <label class="radioStyle" :for="record.userCode"></label>
            </label>
          </span>
        </a-table>
      </div>
    </a-modal>

    <ManuscriptInfo ref="manuscriptInfo" :infoData="manuscript" />
  </div>
</template>


<script>
const editorColumns = [
  {
    title: "选择",
    dataIndex: "sel",
    scopedSlots: { customRender: "select" },
  },
  {
    title: "用户账号",
    dataIndex: "userName",
  },
  {
    title: "用户姓名",
    dataIndex: "name",
  },
  {
    title: "用户角色",
    dataIndex: "roleName",
  },
];
const columns = [
  {
    title: "序号",
    dataIndex: "sort",
    width: 60,
    scopedSlots: { customRender: "sort" },
  },
  {
    title: "稿件编号",
    dataIndex: "code",
    width: 130,
    scopedSlots: { customRender: "code" },
  },
  {
    title: "标题",
    dataIndex: "cnTitle",
    scopedSlots: { customRender: "cnTitle" },
  },
  {
    title: "学科",
    dataIndex: "discipline",
  },
  {
    title: "作者",
    width: 90,
    dataIndex: "authorName",
  },
  {
    title: "所在单位",
    dataIndex: "companyName",
  },
  {
    title: "版本",
    width: 130,
    dataIndex: "sectionInfo",
  },
  {
    title: "建议栏目",
    dataIndex: "columnInfo",
  },
  {
    title: "稿件字数",
    width: 90,
    dataIndex: "wordCount",
  },
  {
    title: "稿件状态",
    width: 90,
    dataIndex: "readStatus",
    scopedSlots: { customRender: "readStatus" },
  },
  {
    title: "操作",
    width: 140,
    key: "action",
    scopedSlots: { customRender: "operator" },
  },
];

import qs from "qs";
import ManuscriptInfo from "../../../commomon/ManuscriptInfo.vue";
export default {
  name: "MyManuscripts",
  components: {
    ManuscriptInfo,
  },
  data() {
    return {
      serviceAddress: this.$config.serviceAddress,
      giveUserCode: "",
      giveVisible: false,
      toOtherCode: "",
      manuscript: {},
      editorData: [],
      editorColumns,
      data: [],
      columns,
      selectedRowKeys: [],
      queryCode: "",
      queryCnTitle: "",
      queryAuthorName: "",
      queryType: "",
      queryEditorName: "",
      queryReadStatus: "",
      sort: "1",
      sortField: "code",
      sortType: "desc",
      operateCode: "0",
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
      };
    },
  },
  created() {
    this.query();
    this.queryEditor();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;
  },
  methods: {
    queryEditor() {
      this.giveUserCode = "";
      this.axios
        .get("/systemUser/queryEditor", {
          params: {
            roleName: "责编",
            name: this.queryEditorName,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          this.editorData = res.data;
          var userCode = sessionStorage.getItem("userCode");
          this.editorData.forEach(function (value) {
            value.roleName = "责编";
          });
          for (var i = 0; i < this.editorData.length; i++) {
            if (this.editorData[i].userCode == userCode) {
              this.editorData.splice(i, 1);
            }
          }
          for (var j = 0; j < this.editorData.length; j++) {
            if (this.editorData[j].isEdit == 1) {
              this.giveUserCode = this.editorData[j].userCode;
            }
          }
        });
    },
    //预览稿件
    preview(record) {
      var codes = [];
      codes.push(record.code);
      this.axios
        .post("/manuscriptsAddFile/queryByCode", {
          codes: JSON.stringify(codes),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            var addFile = res.data.data;
            if (addFile.length > 0) {
              this.$router.push({
                path: "/edit/preview",
                query: { fileCode: addFile[0].code },
              });
            } else {
              this.utils.messageInfo(this, "error", "稿件不存在！");
            }
          } else {
            this.utils.messageInfo(this, "error", "查询稿件失败！");
          }
        });
    },
    giveChange(userCode) {
      this.giveUserCode = userCode;
    },
    giveOk() {
      if (this.giveUserCode == "") {
        this.utils.messageInfo(this, "error", "请选择转让的责编！");
        return;
      }
      this.axios
        .post("/mineManuscripts/updateMineManuscripts", {
          code: this.toOtherCode,
          userCode: this.giveUserCode,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "操作成功");
            this.giveVisible = false;
            this.query();
          } else {
            this.utils.messageInfo(this, "error", res.data.data);
          }
        });
    },
    manuscriptsInfo(record) {
      this.manuscript = record;
      this.$refs.manuscriptInfo.show();
    },
    manage(record) {
      this.$router.push({
        path: "/deal/manager",
        query: {
          code: record.code,
          auditStatus: record.auditStatus,
        },
      });
    },
    toOther(record) {
      this.queryEditorName = "";
      this.queryEditor();
      this.toOtherCode = record.code;
      this.giveVisible = true;
    },
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    sortChange() {
      if (this.sort == 1) {
        this.sortField = "code";
        this.sortType = "desc";
      } else if (this.sort == 2) {
        this.sortField = "code";
        this.sortType = "";
      } else if (this.sort == 3) {
        this.sortField = "create_time";
        this.sortType = "desc";
      } else if (this.sort == 4) {
        this.sortField = "create_time";
        this.sortType = "";
      }
      this.query();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    editorOnSelectChange(editorSelectedRowKeys) {
      this.editorSelectedRowKeys = editorSelectedRowKeys;
    },
    operateChange() {
      var itemLegth = this.selectedRowKeys.length;
      if (itemLegth == 0) {
        this.utils.messageInfo(this, "error", "最少选择一条数据！");
        return;
      }
      if (this.operateCode == 1) {
        if (this.serviceAddress == "") {
          this.utils.messageInfo(
            this,
            "error",
            "获取后台ip地址失败，无法导出！"
          );
          return;
        }
        var selectedRowKeys = this.selectedRowKeys;
        window.open(
          this.serviceAddress +
            "/manuscripts/exportData?codeArr=" +
            selectedRowKeys +
            "&type=2"
        );
      } else if (this.operateCode == 2) {
        //批量下载
      }
    },
    query() {
      this.axios
        .get("/manuscripts/myManuscripts", {
          params: {
            code: this.queryCode,
            cnTitle: this.queryCnTitle,
            authorName: this.queryAuthorName,
            type: this.queryType,
            status: 2,
            auditStatus: 0,
            userCode: sessionStorage.getItem("userCode"),
            readStatus: this.queryReadStatus,
            sortField: this.sortField,
            sortType: this.sortType,
            page: this.page,
            limit: this.limit,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询稿件列表失败！");
          }
        });
    },
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style scoped>
</style>
